import React from 'react';
import PageBase from '../../../widgets/PageBase/PageBase';
import CategoryTemplate from '../../../widgets/MRS/CategoryTemplate';
import { formatNumber } from '../../../../utils/format-number-util';
import ApproveTable from '../../../widgets/MRS/ApproveTable/ApproveTable';
import ApproveLineItem from '../../../widgets/MRS/ApproveLineItem/ApproveLineItem';
import { getFillItemDescById, getFillItemNameById, itemSortMap } from '../../../../utils/mrs-util';

const ApprovePage = (props) => {
  const getTotal = () => {
    return props.items.reduce((total, lineItem) => {
      return total + lineItem.adjustedPrice.priceItem * lineItem.quantity;
    }, 0);
  };
  // Sort the items by description
  const sortedItems = props.items
    .sort((a, b) => {
      return a.subCategorySort - b.subCategorySort
      || getFillItemDescById(a, props.items).localeCompare(getFillItemDescById(b, props.items))
      || itemSortMap[a.itemCategory] - itemSortMap[b.itemCategory]
      || a.description.localeCompare(b.description)
    });

  return (
    <div>
      <PageBase navigation={['MRS']} includeInactiveBranches>
        <CategoryTemplate
          categoryName="MRS Summary"
          customer={props.customer}
          handleNext={props.handleApprove}
          handleBack={props.handleDelete}
          backLabel="Delete"
          nextLabel="Approve"
        >
          <div style={{ textAlign: 'center', marginBottom: 10 }}>
            <h4>Total: ${formatNumber(getTotal(), 2)}</h4>
          </div>
          <ApproveTable>
            {sortedItems.map((item) => (
              <ApproveLineItem
                item={item}
                quantity={item.quantity}
                originalQuantity={item.originalQuantity}
                frequency={item.frequency}
                originalFrequency={item.originalFrequency}
                rate={item.adjustedPrice.priceItem || 0}
                originalRate={item.originalPrice.priceItem || 0}
                quitProduct={item.quitProduct}
                owGroup={getFillItemNameById(item, props.items)}
              />
            ))}
          </ApproveTable>
        </CategoryTemplate>
      </PageBase>
    </div>
  );
};

export default ApprovePage;
